$(document).ready(function(){
  $(document).on('click','.faceted-filter-group-display__more',function(){
     $(this).parents('ul').find('li').show();
     $(this).hide();
  });

  const searchCollection = $('.search-form--collection');
  const searchInput = searchCollection.find('.search-form__input');
  const searchText = searchCollection.find('.search-text');
  const searchSubmit = searchCollection.find('.search-form__submit-button');
  console.log(searchSubmit)
  searchInput.on('focus',()=>{
    searchText.hide();
    searchSubmit.addClass('search--focused');
    searchInput.addClass('search--padding');
  });

  searchInput.on('blur', () => {
    if(searchInput.val() == ''){
      searchText.show();
      searchSubmit.removeClass('search--focused');
      searchInput.removeClass('search--padding');
    }
  });
  
})